import { z } from 'zod';

// The store's own stylesheet — `assets/custom.css` in the code editor. The server runs the full policy
// with a real CSS parser before it stores one; this is the cheap guard both ends share, used on the
// preview message and the storefront payload, so a stylesheet that could break out of its `<style>` or
// pull in another one is refused wherever it travels.

/** The most one store's stylesheet may weigh. */
export const MAX_CUSTOM_CSS_BYTES = 65_536;

/** The things a stylesheet may never carry: an end to its own tag, another sheet, or script. */
const FORBIDDEN = /<\/style|<!--|@import|expression\s*\(|javascript:/i;

// Measures a stylesheet in bytes, the way it is stored and sent, rather than in characters.
export const cssBytes = (css: string): number => new TextEncoder().encode(css).length;

/** A stylesheet as it may be stored, previewed or sent to a shopper. */
export const CustomCssSchema = z.string()
  .refine((css) => cssBytes(css) <= MAX_CUSTOM_CSS_BYTES, `A stylesheet may weigh at most ${MAX_CUSTOM_CSS_BYTES / 1024} KB`)
  .refine((css) => !FORBIDDEN.test(css), 'A stylesheet may not import another, run script or close its own tag');
